import { Container, styled } from "@mui/material";

const RowContainer = styled(Container)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  padding: "15px",
  flexDirection: "row",
});

export default RowContainer;
